module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_8017.7a6e09a0.png";